import { TableHeader } from '@/components/data-table/DataTable';
import { RestrictType } from '@/interfaces/RestrictType';
import { Model } from '@/models/Model';
import { formatDate } from '@/support/String';
import { thumbnailTransformer } from '@/support/ThumbnailTransformer';
import { Media } from './Media';

// #region MODEL

export type GoodsInIncludeType = 'media';

export enum GoodsInTypeEnum {
  PURCHASE_ORDER = 'PurchaseOrder',
}

export interface GoodsInFilterInterface {
  purchase_order_number?: string;
};

export type GoodsInFilterKeyType = keyof GoodsInFilterInterface;

export class GoodsIn extends Model{
  protected $name: string = 'GoodsIn';

  protected $endpoint: string = '/peoplevox-goods-in-summary';

  protected $fillable: GoodsInKeyType[] = [];

  protected $includes: GoodsInIncludeType[] = [];

  protected filters: GoodsInFilterInterface = {};

  public id?: string;

  public item_code?: string;

  public item_name?: string;

  public item_barcode?: string;

  public delivery_date?: string;

  public quantity?: string;

  public delivery_note_number?: string;

  public goods_in_reference_number?: string;

  public attribute1?: string;

  public attribute6?: string;

  public created_at?: string;

  public updated_at?: string;

  public media?: Media[];


  public include(includes: GoodsInIncludeType | GoodsInIncludeType[]): this {
    return super.include.call(this, includes);
  }

  public removeFilter(key: GoodsInFilterKeyType): this {
    return super.removeFilter.call(this, key);
  }

  public filter(filters: GoodsInFilterKeyType | GoodsInFilterInterface, value?: any) {
    return super.filter.call(this, filters, value);
  }
}

export type GoodsInKeyType = Exclude<keyof GoodsIn, keyof Model>;

// #endregion

// #region MODEL: TABLE HEADER

export type GoodsInTableHeaderKeys = Exclude<GoodsInKeyType, 'item_code' | 'item_barcode' | 'attribute1' | 'attribute6' | 'created_at' | 'updated_at' | 'id' >;

export class GoodsInTableHeaderClass implements RestrictType<GoodsInTableHeaderKeys, TableHeader, GoodsInTableHeaderClass> {

  get media(): TableHeader {
    return {
      value: 'media',
      text: '',
      width: '1%',
      transform: (media: any) => media.length ? thumbnailTransformer(media[0].url_thumbnail) : '',
    }
  }

  get item_name(): TableHeader {
    return {
      value: 'item_name',
      text: 'Name',
      transform: (name: string, item: GoodsIn) => {
        return `<div class="item_name">${item.item_name}</div><div class="attribute6">${item.attribute6}</div><div class="attribute1">${item.attribute1}</div>`;
      }
    }
  }

  get delivery_date(): TableHeader {
    return {
      value: 'delivery_date',
      text: 'Date',
      class: 'text-right white-space-no-wrap',
      transform: (date: string) => date ? formatDate(date, 'dd-LL-yyyy') : '',
    }
  }

  get goods_in_reference_number(): TableHeader {
    return {
      value: 'goods_in_reference_number',
      text: 'Goods In reference',
    }
  }

  get quantity(): TableHeader {
    return {
      value: 'quantity',
      text: 'Received',
      class: 'text-right',
    }
  }

  get delivery_note_number(): TableHeader {
    return {
      value: 'delivery_note_number',
      text: 'Delivery Note No.',
    }
  }
}

export const GoodsInTableHeader = new GoodsInTableHeaderClass();

// #endregion
